import { render, staticRenderFns } from "./SectionLapCheckpoint.vue?vue&type=template&id=fdcb5f24&"
import script from "./SectionLapCheckpoint.vue?vue&type=script&lang=js&"
export * from "./SectionLapCheckpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports